<div class="list-group-item list-group-item-action clickable" [ngClass]="{'active': isActive}">
  <div (click)="onNodeClicked(node)"><span class="fa fa-plus-circle"></span> {{node.data.name}}</div>
  @if (node.children && node.children.length) {
    <div class="list-group">
      @for (child of node.children; track child) {
        <org-unit-node [node]="child" (onClicked)="onNodeClicked($event)"></org-unit-node>
      }
    </div>
  }
</div>
